/* eslint-disable react/prop-types */
import { OverlayTrigger, Popover } from 'react-bootstrap';

const PopoverTrigger = ({
  variant = 'secondary',
  title,
  message,
  trigger = ['hover,focus'],
  placement = 'bottom',
  popHeaderProps,
  onToggle = () => {},
  children,
  ...props
}) => (
  <OverlayTrigger
    trigger={trigger}
    placement={placement}
    overlay={
      <Popover id="popover-basic">
        {title && (
          <Popover.Header
            className={`bg-${variant}-100 text-${variant}`}
            as="h5"
            {...popHeaderProps}
          >
            {title}
          </Popover.Header>
        )}
        <Popover.Body>{message}</Popover.Body>
      </Popover>
    }
    onToggle={onToggle}
  >
    <div className="cursor-pointer" {...props}>
      {children}
    </div>
  </OverlayTrigger>
);

export default PopoverTrigger;
